import Head from "next/head";
import dynamic from "next/dynamic";

import { Breakpoint } from "../../utils/media-query";
import { useEffect, useState } from "react";
const Loading = () => <p>Loading...</p>;

const ArticleContent = dynamic(
  () => import("../../components/articlepage/content"),
  {
    loading: Loading,
  }
);
const ArticleHeadline = dynamic(
  () => import("../../components/articlepage/headline"),
  {
    loading: Loading,
  }
);
const ArticleThumbnail = dynamic(
  () => import("../../components/articlepage/thumbnail"),
  {
    loading: Loading,
  }
);
const PagingArticle = dynamic(
  () => import("../../components/articlepage/paging"),
  {
    loading: Loading,
  }
);
const ArticlePage = ({ article, prevArticle, nextArticle }) => {
  const [isMounted, setIsMounted] = useState(false);
  useEffect(() => {
    setIsMounted(true);
  }, []);

  const [isDesktop, isTablet, isMobile] = Breakpoint();
  const pageTitle = `${article.title} | Aurum Lab`;

  return (
    <>
      <Head>
        <title>{pageTitle}</title>
        <meta name="description" content={article.description} />
      </Head>
      <main>
        {isMounted && (
          <>
            <div className={isMobile ? "container-mobile" : "container"}>
              <div className="center">
                <div className="article-width">
                  <ArticleHeadline headline={article.headline} />
                  <ArticleThumbnail
                    thubmnail={article.thumbnail}
                    title={article.title}
                  />
                  <ArticleContent content={article.content} />
                  <PagingArticle
                    prevArticle={prevArticle}
                    nextArticle={nextArticle}
                  />
                </div>
              </div>
            </div>
          </>
        )}
      </main>
    </>
  );
};
export default ArticlePage;

// export const getStaticPaths = async () => {
//   // Fetch the list of possible values for the dynamic segment
//   const api_url = process.env.API_URL;

//   const response = await fetch(`${api_url}api/article/slug/all`); // Adjust the API endpoint as needed

//   if (!response.ok) {
//     return {
//       paths: [], // Return an empty array if there are no dynamic paths
//       fallback: "blocking", // or 'false' if you want to return a 404 for unknown paths
//     };
//   }

//   const data = await response.json();
//   const paths = data.map((article) => ({
//     params: { article: article.slug },
//   }));

//   return {
//     paths,
//     fallback: "blocking", // You can choose 'blocking' or 'true' here based on your requirements
//   };
// };

export const getServerSideProps = async (context) => {
  try {
    const { params } = context;
    const { article } = params;
    const api_url = process.env.API_URL;
    const response = await fetch(`${api_url}api/article/slug?q=${article}`);
    const { currentArticle, prevArticle, nextArticle } = await response.json();

    if (!response.ok || !currentArticle) {
      return {
        notFound: true,
      };
    }
    return {
      props: {
        article: currentArticle,
        prevArticle,
        nextArticle,
      },
    };
  } catch (err) {
    return {
      notFound: true,
    };
  }
};
